import React from "react";
import { Card, CardContent, ButtonBase, Stack, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { selectInvitationState } from "../../sagas/invitations/invitationSlice";
import { ResidentpageState } from "../../ResidentpageState";

interface PropsType {
  setPageState: React.Dispatch<React.SetStateAction<ResidentpageState>>;
  setSelectedProperty: React.Dispatch<React.SetStateAction<string>>;
}

const useStyles = makeStyles({
  text: {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "21px",
    color: "#14142B",
  },
  card: {
    "&.MuiCard-root": {
      width: "100%",
      backgroundColor: "#ffffff",
      boxShadow: "rgb(0 0 0 / 10%) 0px 0px 40px",
      borderRadius: "20px",
      marginBottom: "16px",
    },
  },
  cardContainer: {
    maxHeight: 460,
    overflow: "auto",
    padding: "36px 40px 20px",
    width: "100%",
    marginTop: "0 !important",
  },
});

export default function SelectProperty(props: PropsType) {
  const classes = useStyles();

  const { propertyResponse } = useSelector(selectInvitationState);

  const getPropertyCard = (p: any, index: number) => (
    <Card classes={{ root: classes.card }} key={index}>
      <ButtonBase
        sx={{ display: "block", textAlign: "initial", width: "100%" }}
        onClick={() => {
          selectProperty(p);
        }}
      >
        <CardContent sx={{ padding: "14px" }}>
          <Typography sx={{ lineHeight: "23px", fontWeight: "700" }} className={classes.text} gutterBottom>
            {p.CompanyName}
          </Typography>
          <Typography className={classes.text}>{p.Address.Line1}</Typography>
          <Typography className={classes.text}>
            {p.Address.City}, {p.Address.State} {p.Address.Zip}
          </Typography>
        </CardContent>
      </ButtonBase>
    </Card>
  );

  const selectProperty = (property: any) => {
    props.setSelectedProperty(property);
    props.setPageState(ResidentpageState.SearchResidentsByPuuidAndName);
  };

  return (
    <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
      <Box sx={{ width: "200px" }}>
        <Typography className={classes.text} sx={{ textAlign: "center" }}>
          Please select your property from the list.
        </Typography>
      </Box>

      {propertyResponse?.properties?.length ? <Box className={classes.cardContainer}>{propertyResponse.properties.map((p: any, index: number) => getPropertyCard(p, index))}</Box> : <></>}
      <Box sx={{ width: "400px" }}>
        <Typography className={classes.text} sx={{ textAlign: "center" }}>
          Didn't find your unit? Click the back arrow to refine your search.
        </Typography>
      </Box>
    </Stack>
  );
}
